import { logEvent } from './logGaEvent'

// Common function to create cross-sell event attributes
const createCrossSellAttributes = ({
  pageName,
  filterType = '',
  promotionName = 'hotel',
  promotionId = 'xs',
  creativeName = '',
  creativeSlot = '',
  locationId = '',
  bundleFlag = 'y',
  bundleType = 'AH',
}) => ({
  type: 'add_on',
  product_name: 'air',
  page_name: pageName,
  promotion_id: promotionId,
  promotion_name: promotionName,
  creative_name: creativeName,
  creative_slot: creativeSlot,
  location_id: locationId,
  filter_type: filterType,
  bundle_flag: bundleFlag,
  bundle_type: bundleType,
})

// GA4
const logCrossSell = ({ ecommerce, ...rest }) => {
  const event = 'view_promotion'
  const attributes = { event, ...createCrossSellAttributes(rest), ...(ecommerce && { ecommerce }) }
  logEvent(event, attributes)
}

const clickCrossSell = ({ ecommerce, ...rest }) => {
  const event = 'select_promotion'
  const attributes = { event, ...createCrossSellAttributes(rest), ...(ecommerce && { ecommerce }) }
  logEvent(event, attributes)
}

const logCrossSellDisplay = ({ type, itemName, pageName }) => {
  const event = 'display'
  const attributes = {
    event,
    type,
    item_name: itemName,
    page_name: pageName,
    product_name: 'air',
  }
  logEvent(event, attributes)
}

const logPackageMerchandisingPricingClick = ({ linkText = '' }) => {
  const event = 'internal_link'
  const attributes = {
    event,
    link_name: 'select',
    link_text: linkText,
    page_name: 'pkg_flight_listings',
    product_name: 'bundle',
  }
  logEvent(event, attributes, false)
}

export { clickCrossSell, logCrossSell, logCrossSellDisplay, logPackageMerchandisingPricingClick }
